export default "__VITE_ASSET__5f0ab70b__"